import React, { useEffect, useState } from 'react';
export const RpmNoConsentLayout = () => {
    return (React.createElement("div", { style: { display: 'grid', minHeight: '200px', height: '100%', width: '100%', alignContent: 'center' } },
        React.createElement("div", { style: { fontFamily: 'Barlow', fontWeight: 700, textAlign: 'center', color: '#00000099' } }, "Please select a consent option above if applicable.")));
};
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import '@fontsource/lato';
import { DotPhraseMenu } from '~/components/dotPhrases/DotPhraseMenu';
import { getDotPhrasesRequest } from '~/api/dotPhrases/getDotPhrasesRequest';
export const RpmOptInLayout = (props) => {
    const [isDotPhraseMenuOpen, setIsDotPhraseMenuOpen] = useState(false);
    const [dotPhraseAnchorEl, setDotPhraseAnchorEl] = useState(null);
    const [dotPosition, setDotPosition] = useState(0);
    const [dotPhrases, setDotPhrases] = useState([]);
    const [formData, setFormData] = useState({
        consentMethod: props.consentMethod ? props.consentMethod : 'Verbal (Remote)',
        dateTime: props.consentDate ? dayjs(props.consentDate).format('YYYY-MM-DD HH:mm:ss ZZ') : dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss ZZ'),
        dataUsage: true,
        consentNotes: props.consentNotes ? props.consentNotes : '',
        requiredChecks: {
            dataReview: props.optIn,
            communication: props.optIn,
            financial: props.optIn,
            optOut: props.optIn,
            singleProvider: props.optIn
        }
    });
    // update the parent layout when form data changes
    useEffect(() => {
        props.onFormDataChange(formData);
    }, [formData]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleConsentMethodChange = (e) => {
        const { value } = e.target;
        setFormData((prev) => ({ ...prev, consentMethod: value }));
    };
    const handleDateChange = (newValue) => {
        setFormData((prev) => ({ ...prev, dateTime: dayjs(newValue).format('YYYY-MM-DD HH:mm:ss ZZ') }));
    };
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            requiredChecks: { ...prev.requiredChecks, [name]: checked }
        }));
    };
    const allRequiredChecked = Object.values(formData.requiredChecks).every((checked) => checked);
    // notify parent when check boxes are updated
    useEffect(() => {
        props.allRequiredChecks(allRequiredChecked);
    }, [allRequiredChecked]);
    // also notify parent of state on component mount
    useEffect(() => {
        props.allRequiredChecks(allRequiredChecked);
    }, []);
    const handleSubmit = async (e) => {
        e.preventDefault();
        const submissionData = {
            consentMethod: formData.consentMethod,
            dateTime: dayjs(formData.dateTime).format('YYYY-MM-DD HH:mm:ss ZZ'),
            dataUsage: true,
            consentNotes: formData.consentNotes,
            patientId: props.patient.id
        };
        console.log(submissionData);
        // await axios.post('/api/consent/consentPatient', submissionData);
    };
    const handleInput = (e) => {
        const value = e.target.value;
        const cursorPosition = e.target.selectionStart;
        // Check if cursor is right after a dot
        if (cursorPosition > 0 && value[cursorPosition - 1] === '.') {
            setDotPhraseAnchorEl(e.target); // Use the event target as anchor
            setIsDotPhraseMenuOpen(true);
            setDotPosition(cursorPosition - 1);
        }
        else {
            setIsDotPhraseMenuOpen(false);
            setDotPhraseAnchorEl(null); // Use the event target as anchor
        }
    };
    useEffect(() => {
        getDotPhrases();
    }, []);
    const getDotPhrases = async () => {
        const dotPhrases = await getDotPhrasesRequest();
        setDotPhrases(dotPhrases.dotPhrases);
    };
    return props.optIn ? (React.createElement("div", { style: { minHeight: '200px', height: '100%', width: '100%' } },
        React.createElement(Grid, { component: 'form', onSubmit: handleSubmit },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 3 },
                    React.createElement(FormControl, { sx: { m: 1, width: 250, height: '30px' } },
                        React.createElement(InputLabel, { id: "enrollment-method-label" }, "Enrollment Method"),
                        React.createElement(Select, { label: 'Enrollment Method', sx: { height: '30px' }, labelId: "enrollment-method-label", id: "enrollment-method-name", value: formData.consentMethod, onChange: handleConsentMethodChange },
                            React.createElement(MenuItem, { key: 'Verbal (Remote)', value: 'Verbal (Remote)' }, "Verbal (Remote)"),
                            React.createElement(MenuItem, { key: 'In-Person', value: 'In-Person' }, "In-Person"),
                            React.createElement(MenuItem, { key: 'Consent Form (Digital)', value: 'Consent Form (Digital)' }, "Consent Form (Digital)"),
                            React.createElement(MenuItem, { key: 'Consent Form (Physical)', value: 'Consent Form (Physical)' }, "Consent Form (Physical)")))),
                React.createElement(Grid, { item: true, xs: 6 }),
                React.createElement(Grid, { item: true, xs: 3 },
                    React.createElement(FormControl, { sx: { m: 1, width: 200, height: '30px', float: 'right' } },
                        React.createElement("div", { style: { height: 30, width: 200 } },
                            React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                                React.createElement(DateTimePicker, { label: 'Input Date & Time', sx: { '& .MuiInputBase-root': { height: 30, width: 200, fontSize: 'smaller' } }, maxDate: dayjs(new Date()), name: "dateTime", value: dayjs(props.patient.rpmConsentedAt), onChange: handleDateChange })))))),
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 12, style: { paddingLeft: '10px' } },
                    React.createElement("div", { style: { fontFamily: 'Barlow', color: '#1C170D', fontWeight: 700, fontSize: 'medium' } }, "Opt In")),
                React.createElement(Grid, { item: true, xs: 12, style: { paddingLeft: '10px' } },
                    React.createElement("div", { style: { fontFamily: 'Barlow', color: '#00000099', fontWeight: 600, fontSize: 'small' } }, "The patient consents to and indicates understanding that:")),
                React.createElement(FormGroup, { style: { padding: '10px' } }, [
                    {
                        name: 'dataReview',
                        title: 'Data Review Cadence',
                        description: 'Their medical provider(s) will review data typically every 30 days and may contact them to update their regimen, which may include medication or dosage changes, though the frequency may vary based on clinical need.'
                    },
                    {
                        name: 'communication',
                        title: 'Communication',
                        description: 'Their care team may contact them by phone or electronic message to discuss their data and progress, but they may not receive communication every month unless clinically necessary.'
                    },
                    {
                        name: 'financial',
                        title: 'Financial Responsibility',
                        description: 'They may be responsible for costs related to care management activities and device data collection and interpretation, and they may be billed for services even if they do not hear from their care team in a given month.'
                    },
                    {
                        name: 'optOut',
                        title: 'Right to Opt-Out',
                        description: 'They can withdraw consent to participate in this program at any time by reaching out to their care team, effective at the beginning of the following calendar month.'
                    },
                    {
                        name: 'singleProvider',
                        title: 'Single Provider RPM Restriction',
                        description: 'Only one healthcare provider can bill for RPM services at a time and they are not enrolled in another RPM program with any other provider.'
                    }
                ].map(({ name, title, description }) => (React.createElement(FormControlLabel, { key: name, control: React.createElement(Checkbox, { checked: true, onChange: handleCheckboxChange, name: name }), label: React.createElement(Box, { className: 'mb-1' },
                        React.createElement("div", { style: { fontWeight: 600, display: 'inline-flex' } },
                            title,
                            " ",
                            React.createElement("div", { style: { color: '#018FB7' } }, "\u00A0(required)*")),
                        React.createElement("div", { style: { color: '#1C170D', fontWeight: 400, fontFamily: 'Lato, sans-serif', fontSize: 'medium' } }, description)) })))),
                React.createElement(TextField, { style: { padding: '10px' }, label: "Consent Notes", name: "consentNotes", value: formData.consentNotes, onChange: handleChange, fullWidth: true, margin: "normal", multiline: true, rows: 3, onInput: handleInput }),
                isDotPhraseMenuOpen &&
                    React.createElement(DotPhraseMenu, { practiceId: props.patient?.practiceId ? props.patient.practiceId : '', userId: '1', anchorEl: dotPhraseAnchorEl, dotPosition: dotPosition, initialDotPhrases: dotPhrases, dotPhraseSelected: (content) => setFormData((prev) => ({ ...prev, ['consentNotes']: formData.consentNotes + ' ' + content })) }))))) : (React.createElement("div", { style: { minHeight: '200px', height: '100%', width: '100%' } },
        React.createElement(Grid, { component: 'form', onSubmit: handleSubmit },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 3 },
                    React.createElement(FormControl, { sx: { m: 1, width: 250, height: '30px' } },
                        React.createElement(InputLabel, { id: "enrollment-method-label" }, "Enrollment Method"),
                        React.createElement(Select, { label: 'Enrollment Method', sx: { height: '30px' }, labelId: "enrollment-method-label", id: "enrollment-method-name", value: formData.consentMethod, onChange: handleConsentMethodChange },
                            React.createElement(MenuItem, { key: 'Verbal (Remote)', value: 'Verbal (Remote)' }, "Verbal (Remote)"),
                            React.createElement(MenuItem, { key: 'In-Person', value: 'In-Person' }, "In-Person"),
                            React.createElement(MenuItem, { key: 'Consent Form (Digital)', value: 'Consent Form (Digital)' }, "Consent Form (Digital)"),
                            React.createElement(MenuItem, { key: 'Consent Form (Physical)', value: 'Consent Form (Physical)' }, "Consent Form (Physical)")))),
                React.createElement(Grid, { item: true, xs: 6 }),
                React.createElement(Grid, { item: true, xs: 3 },
                    React.createElement(FormControl, { sx: { m: 1, width: 200, height: '30px', float: 'right' } },
                        React.createElement("div", { style: { height: 30, width: 200 } },
                            React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                                React.createElement(DateTimePicker, { label: 'Input Date & Time', sx: { '& .MuiInputBase-root': { height: 30, width: 200, fontSize: 'smaller' } }, maxDate: dayjs(new Date()), name: "dateTime", value: dayjs(formData.dateTime), onChange: handleDateChange })))))),
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 12, style: { paddingLeft: '10px' } },
                    React.createElement("div", { style: { fontFamily: 'Barlow', color: '#1C170D', fontWeight: 700, fontSize: 'medium' } }, "Opt In")),
                React.createElement(Grid, { item: true, xs: 12, style: { paddingLeft: '10px' } },
                    React.createElement("div", { style: { fontFamily: 'Barlow', color: '#00000099', fontWeight: 600, fontSize: 'small' } }, "The patient consents to and indicates understanding that:")),
                React.createElement(FormGroup, { style: { padding: '10px' } }, [
                    {
                        name: 'dataReview',
                        title: 'Data Review Cadence',
                        description: 'Their medical provider(s) will review data typically every 30 days and may contact them to update their regimen, which may include medication or dosage changes, though the frequency may vary based on clinical need.'
                    },
                    {
                        name: 'communication',
                        title: 'Communication',
                        description: 'Their care team may contact them by phone or electronic message to discuss their data and progress, but they may not receive communication every month unless clinically necessary.'
                    },
                    {
                        name: 'financial',
                        title: 'Financial Responsibility',
                        description: 'They may be responsible for costs related to care management activities and device data collection and interpretation, and they may be billed for services even if they do not hear from their care team in a given month.'
                    },
                    {
                        name: 'optOut',
                        title: 'Right to Opt-Out',
                        description: 'They can withdraw consent to participate in this program at any time by reaching out to their care team, effective at the beginning of the following calendar month.'
                    },
                    {
                        name: 'singleProvider',
                        title: 'Single Provider RPM Restriction',
                        description: 'Only one healthcare provider can bill for RPM services at a time and they are not enrolled in another RPM program with any other provider.'
                    }
                ].map(({ name, title, description }) => (React.createElement(FormControlLabel, { key: name, control: React.createElement(Checkbox, { checked: formData.requiredChecks[name], onChange: handleCheckboxChange, name: name }), label: React.createElement(Box, { className: 'mb-1' },
                        React.createElement("div", { style: { fontWeight: 600, display: 'inline-flex' } },
                            title,
                            " ",
                            React.createElement("div", { style: { color: '#018FB7' } }, "\u00A0(required)*")),
                        React.createElement("div", { style: { color: '#1C170D', fontWeight: 400, fontFamily: 'Lato, sans-serif', fontSize: 'medium' } }, description)) })))),
                React.createElement(TextField, { style: { padding: '10px' }, label: "Consent Notes", name: "consentNotes", value: formData.consentNotes, onChange: handleChange, fullWidth: true, margin: "normal", multiline: true, rows: 3, onInput: handleInput }),
                isDotPhraseMenuOpen &&
                    React.createElement(DotPhraseMenu, { practiceId: props.patient?.practiceId ? props.patient.practiceId : '', userId: '1', anchorEl: dotPhraseAnchorEl, dotPosition: dotPosition, initialDotPhrases: dotPhrases, dotPhraseSelected: (content) => setFormData((prev) => ({ ...prev, ['consentNotes']: formData.consentNotes + ' ' + content })) })))));
};
import '@fontsource/lato';
export const RpmOptOutLayout = (props) => {
    const [isDotPhraseMenuOpen, setIsDotPhraseMenuOpen] = useState(false);
    const [dotPhraseAnchorEl, setDotPhraseAnchorEl] = useState(null);
    const [dotPosition, setDotPosition] = useState(0);
    const [dotPhrases, setDotPhrases] = useState([]);
    const [formData, setFormData] = useState({
        optOutReason: props.optOutReason ? props.optOutReason : 'Financial Concerns',
        dateTime: props.optOutDate ? dayjs(props.optOutDate).format('YYYY-MM-DD HH:mm:ss ZZ') : dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss ZZ'),
        optOutNotes: props.optOutNotes ? props.optOutNotes : '',
        requiredChecks: {
            optOut: props.optOut,
        }
    });
    useEffect(() => {
        props.onFormDataChange(formData);
    }, [formData]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const handleMethodChange = (e) => {
        const { value } = e.target;
        setFormData((prev) => ({ ...prev, optOutReason: value }));
    };
    const handleDateChange = (newValue) => {
        setFormData((prev) => ({ ...prev, dateTime: dayjs(newValue).format('YYYY-MM-DD HH:mm:ss ZZ') }));
    };
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            requiredChecks: { ...prev.requiredChecks, [name]: checked }
        }));
    };
    const allRequiredChecked = Object.values(formData.requiredChecks).every((checked) => checked);
    useEffect(() => {
        props.allRequiredChecks(allRequiredChecked);
    }, [allRequiredChecked]);
    useEffect(() => {
        props.allRequiredChecks(allRequiredChecked);
    }, []);
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('on submit');
        const submissionData = {
            optOutReason: formData.optOutReason,
            dateTime: dayjs(formData.dateTime).format('YYYY-MM-DD HH:mm:ss ZZ'),
            optOutNotes: formData.optOutNotes,
            patientId: props.patient.id
        };
        console.log(submissionData);
    };
    const handleInput = (e) => {
        const value = e.target.value;
        const cursorPosition = e.target.selectionStart;
        // Check if cursor is right after a dot
        if (cursorPosition > 0 && value[cursorPosition - 1] === '.') {
            setDotPhraseAnchorEl(e.target); // Use the event target as anchor
            setIsDotPhraseMenuOpen(true);
            setDotPosition(cursorPosition - 1);
        }
        else {
            setIsDotPhraseMenuOpen(false);
            setDotPhraseAnchorEl(null); // Use the event target as anchor
        }
    };
    useEffect(() => {
        getDotPhrases();
    }, []);
    const getDotPhrases = async () => {
        const dotPhrases = await getDotPhrasesRequest();
        setDotPhrases(dotPhrases.dotPhrases);
    };
    if (props.optOut) {
        return (React.createElement("div", { style: { minHeight: '200px', height: '100%', width: '100%' } },
            React.createElement(Grid, { component: 'form', onSubmit: handleSubmit },
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(FormControl, { sx: { m: 1, width: 250, height: '30px' } },
                            React.createElement(InputLabel, { id: "optout-label" }, "Opt Out Reason"),
                            React.createElement(Select, { label: 'Opt Out Reason', sx: { height: '30px' }, labelId: "optout-label", id: "optout-reason", value: formData.optOutReason, onChange: handleMethodChange },
                                React.createElement(MenuItem, { key: 'Financial Concerns', value: 'Financial Concerns' }, "Financial Concerns"),
                                React.createElement(MenuItem, { key: 'Prefers In-Person Care', value: 'Prefers In-Person Care' }, "Prefers In-Person Care"),
                                React.createElement(MenuItem, { key: 'Indicates Monitoring Not Necessary', value: 'Indicates Monitoring Not Necessary' }, "Indicates Monitoring Not Necessary"),
                                React.createElement(MenuItem, { key: 'Other', value: 'Other' }, "Other")))),
                    React.createElement(Grid, { item: true, xs: 6 }),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(FormControl, { sx: { m: 1, width: 200, height: '30px', float: 'right' } },
                            React.createElement("div", { style: { height: 30, width: 200 } },
                                React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                                    React.createElement(DateTimePicker, { label: 'Input Date & Time', sx: { '& .MuiInputBase-root': { height: 30, width: 200, fontSize: 'smaller' } }, maxDate: dayjs(new Date()), name: "dateTime", value: dayjs(props.patient.rpmConsentedAt), onChange: handleDateChange })))))),
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, xs: 12, style: { paddingLeft: '10px' } },
                        React.createElement("div", { style: { fontFamily: 'Barlow', color: '#D32F2F', fontWeight: 700, fontSize: 'medium' } }, "Opt Out")),
                    React.createElement(FormGroup, { style: { padding: '10px' } }, [
                        {
                            name: 'optOut',
                            title: 'Opt Out of Sweetspot',
                            description: 'The patient would like to opt out of remote patient monitoring'
                        }
                    ].map(({ name, title, description }) => (React.createElement(FormControlLabel, { key: name, control: React.createElement(Checkbox, { checked: true, onChange: handleCheckboxChange, name: name }), label: React.createElement(Box, { className: 'mb-1' },
                            React.createElement("div", { style: { fontWeight: 600, display: 'inline-flex' } },
                                title,
                                " ",
                                React.createElement("div", { style: { color: '#018FB7' } }, "\u00A0(required)*")),
                            React.createElement("div", { style: { color: '#1C170D', fontWeight: 400, fontFamily: 'Lato, sans-serif', fontSize: 'medium' } }, description)) })))),
                    React.createElement(TextField, { style: { padding: '10px' }, label: "Opt Out Notes", name: "optOutNotes", value: formData.optOutNotes, onChange: handleChange, fullWidth: true, margin: "normal", multiline: true, rows: 3, onInput: handleInput }),
                    isDotPhraseMenuOpen &&
                        React.createElement(DotPhraseMenu, { practiceId: props.patient?.practiceId ? props.patient.practiceId : '', userId: '1', anchorEl: dotPhraseAnchorEl, dotPosition: dotPosition, initialDotPhrases: dotPhrases, dotPhraseSelected: (content) => setFormData((prev) => ({ ...prev, ['optOutNotes']: formData.optOutNotes + ' ' + content })) })))));
    }
    else {
        return (React.createElement("div", { style: { minHeight: '200px', height: '100%', width: '100%' } },
            React.createElement(Grid, { component: 'form', onSubmit: handleSubmit },
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(FormControl, { sx: { m: 1, width: 250, height: '30px' } },
                            React.createElement(InputLabel, { id: "enrollment-method-label" }, "Opt Out Reason"),
                            React.createElement(Select, { label: 'Opt Out Reason', sx: { height: '30px' }, labelId: "enrollment-method-label", id: "enrollment-method-name", value: formData.optOutReason, onChange: handleMethodChange },
                                React.createElement(MenuItem, { key: 'Financial Concerns', value: 'Financial Concerns' }, "Financial Concerns"),
                                React.createElement(MenuItem, { key: 'Prefers In-Person Care', value: 'Prefers In-Person Care' }, "Prefers In-Person Care"),
                                React.createElement(MenuItem, { key: 'Indicates Monitoring Not Necessary', value: 'Indicates Monitoring Not Necessary' }, "Indicates Monitoring Not Necessary"),
                                React.createElement(MenuItem, { key: 'Other', value: 'Other' }, "Other")))),
                    React.createElement(Grid, { item: true, xs: 6 }),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(FormControl, { sx: { m: 1, width: 200, height: '30px', float: 'right' } },
                            React.createElement("div", { style: { height: 30, width: 200 } },
                                React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                                    React.createElement(DateTimePicker, { label: 'Input Date & Time', sx: { '& .MuiInputBase-root': { height: 30, width: 200, fontSize: 'smaller' } }, maxDate: dayjs(new Date()), name: "dateTime", value: dayjs(formData.dateTime), onChange: handleDateChange })))))),
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, xs: 12, style: { paddingLeft: '10px' } },
                        React.createElement("div", { style: { fontFamily: 'Barlow', color: '#D32F2F', fontWeight: 700, fontSize: 'medium' } }, "Opt Out")),
                    React.createElement(FormGroup, { style: { padding: '10px' } }, [
                        {
                            name: 'optOut',
                            title: 'Opt Out of Sweetspot',
                            description: 'The patient would like to opt out of remote patient monitoring'
                        }
                    ].map(({ name, title, description }) => (React.createElement(FormControlLabel, { key: name, control: React.createElement(Checkbox, { checked: formData.requiredChecks[name], onChange: handleCheckboxChange, name: name }), label: React.createElement(Box, { className: 'mb-1' },
                            React.createElement("div", { style: { fontWeight: 600, display: 'inline-flex' } },
                                title,
                                " ",
                                React.createElement("div", { style: { color: '#018FB7' } }, "\u00A0(required)*")),
                            React.createElement("div", { style: { color: '#1C170D', fontWeight: 400, fontFamily: 'Lato, sans-serif', fontSize: 'medium' } }, description)) })))),
                    React.createElement(TextField, { style: { padding: '10px' }, label: "Opt Out Notes", name: "optOutNotes", value: formData.optOutNotes, onChange: handleChange, fullWidth: true, margin: "normal", multiline: true, rows: 3, onInput: handleInput }),
                    isDotPhraseMenuOpen &&
                        React.createElement(DotPhraseMenu, { practiceId: props.patient?.practiceId ? props.patient.practiceId : '', userId: '1', anchorEl: dotPhraseAnchorEl, dotPosition: dotPosition, initialDotPhrases: dotPhrases, dotPhraseSelected: (content) => setFormData((prev) => ({ ...prev, ['optOutNotes']: formData.optOutNotes + ' ' + content })) })))));
    }
};
